// extracted by mini-css-extract-plugin
module.exports = {"carousel":"photo_slider_carousel__kchbc","carouselItem":"photo_slider_carouselItem__2qSpb","boxArrows":"photo_slider_boxArrows__1Hi2d"};